

import { useNavigate } from 'react-router-dom';
import { NavBar } from '../NavBar';
import './index.scss'
import { isMobile } from '@/utils/util';
import { useEffect } from 'react';

interface ErrorPageProps {
  message?: string;
  onRetry?: () => void;
}

function ErrorPage({ message, onRetry }: ErrorPageProps) {

  const navigate = useNavigate()
  useEffect(() => {
    if (message != undefined) {
      const timer = setInterval(() => {
        window.location.hash = '#/'
      }, 100)

      return () => {
        clearInterval(timer)
      };
    }
  }, [])

  const handleRetry = () => {
    onRetry && onRetry()
  }



  return (
    <div className={isMobile() ? 'error' : 'pc-error'}>
      <NavBar backTitle="返回首页" onBackClick={() => {
        navigate('/', { replace: true })
      }} />
      <div className='message-pop'>
        <p className="message" onClick={handleRetry}>{message ?? ''}</p>
      </div>
    </div>
  );
}

export default ErrorPage;
